import React, { useState } from "react";
import { Input, Uploader } from "rsuite";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { FileType } from "rsuite/esm/Uploader";
import { PageHeader } from "../../SharedComponents/PageHeader";
import * as uploadDb from "../../Services/FileUploadsDB";
export const FileUpload = () => {
  const Kra_url = uploadDb.KraUrl();
  const pw_url = uploadDb.pwUrl();
  const attration_url = uploadDb.AttrationUrl();
  const attendance_url = uploadDb.AttendanceUrl();

  const onEmployeeDataUpload = (e: any) => {
    let selectedFile: any = e.target.files[0];
    const formData = new FormData();
    formData.append("body", selectedFile);
    uploadDb.UploadEmployeeEntries(formData).then((res) => {});
  };

  return (
    <>
      <div>
        <PageHeader title="Data Uploads" backPage="">
          <></>
        </PageHeader>
        <hr />
        <div className="d-flex flex-row justify-content-start gap-3">
          <div className="card w-auto h-auto mt-2">
            <Uploader
              action={pw_url}
              onSuccess={(response: string, file: FileType) => {
                if (response) toast.success("Uploaded Successfully.");
                else toast.error("Failed !");
              }}
              onProgress={(percent: number, file: FileType) =>
                toast.warning("Uploading...")
              }
              draggable
            >
              <div style={{ lineHeight: "auto" }}>
                Click or Drag files to this area to upload
              </div>
            </Uploader>

            <div className="card-body">
              <h5 className="card-title">Employee Details Upload</h5>
              <div className="card-subtitle mb-4">
                <a href="/PW_template.xlsx" download>
                  Download PW Template
                </a>
              </div>
            </div>
          </div>

          <div className="card   w-auto h-auto mt-2">
            <Uploader
              action={Kra_url}
              onSuccess={(response: object, file: FileType) =>
                toast.success("Uploaded Successfully.")
              }
              onProgress={(percent: number, file: FileType) =>
                toast.warning("Uploading...")
              }
              draggable
            >
              <div style={{ lineHeight: "auto" }}>
                Click or Drag files to this area to upload
              </div>
            </Uploader>
            <div className="card-body">
              <h5 className="card-title">KRA Details Upload</h5>
              <div className="d-flex flex-column">
                <a href="/KRA_template.xlsx" download>
                  Download KRA Template
                </a>
              </div>
            </div>
          </div>

          {/* <div className="card   w-auto h-auto mt-2" >
                    <Uploader action={attration_url} onSuccess={(response: object, file: FileType) => toast.success('Uploaded Successfully.')} onProgress={(percent: number, file: FileType) => toast.warning('Uploading...')} draggable>
                        <div style={{ lineHeight: 'auto' }}>Click or Drag files to this area to upload</div>
                    </Uploader>
                    <div className="card-body">
                        <h5 className="card-title">Attrition Upload</h5>
                        <div className="d-flex flex-column">
                            <a href='/Attrition_template.xlsx' download >Download Attrition Template</a>
                        </div>
                    </div>
                </div> */}
          <div className="card   w-auto h-auto mt-2">
            <Uploader
              action={attendance_url}
              onSuccess={(response: object, file: FileType) =>
                toast.success("Uploaded Successfully.")
              }
              onProgress={(percent: number, file: FileType) =>
                toast.warning("Uploading...")
              }
              draggable
            >
              <div style={{ lineHeight: "auto" }}>
                Click or Drag files to this area to upload
              </div>
            </Uploader>
            <div className="card-body">
              <h5 className="card-title">Attendance Upload</h5>
              <div className="d-flex flex-column">
                <a href="/Attendance_template.xlsx" download>
                  Download Attendance Template
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
